/* eslint-disable import/no-unresolved */
import KeenSlider from 'https://cdn.skypack.dev/keen-slider@6.6.10'
/* eslint-enable import/no-unresolved */

const { debounce } = window.BAO.Utils

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class CarouselWithTitle extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    // Do not initialise if there are not enough slides.
    const slideCount = this.els?.slide?.elements?.length || 0
    if (slideCount < 2) return
    if (window.innerWidth >= 768 && slideCount < 3) return
    if (window.innerWidth >= 901 && slideCount < 4) return

    this.initialiseCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.initialiseCarousel = this.initialiseCarousel.bind(this)

    this.listeners.add(window, 'resize', debounce(this.initialiseCarousel, 100))
  }

  initialiseCarousel () {
    this.destroyCarousel()

    this.carousel = this.setupCarousel()
  }

  destroyCarousel () {
    if (this.carousel && typeof this.carousel.destroy === 'function') {
      this.carousel.destroy()
      this.carousel = null
    }
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 1.5,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.5,
              spacing: 15,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3.5,
              spacing: 15,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('carousel-wth-title')) {
  customElements.define('carousel-wth-title', CarouselWithTitle)
}
